import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { EmailNotificationSetting } from "src/app/model/notification/EmailNotificationSetting";
import { AppState } from "src/app/state";
import * as EmailNotificationSettingsActions from "src/app/state/email-notification-settings/email-notification-settings.actions";
import {
    selectEmailNotificationSettings,
    selectEmailNotificationSettingsError,
    selectEmailNotificationSettingsLoading,
    selectEmailNotificationSettingsUpdatingEventCode,
} from "src/app/state/email-notification-settings/email-notification-settings.selectors";

@Component({
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
    ],
    selector: "app-email-notification-settings",
    templateUrl: "./email-notification-settings.component.html",
    styleUrls: ["./email-notification-settings.component.scss"],
})
export class EmailNotificationSettingsComponent implements OnInit {
    settings$: Observable<EmailNotificationSetting[]>;
    loading$: Observable<boolean>;
    error$: Observable<string | null>;
    updatingEventCode$: Observable<string | null>;
    readonly displayedColumns = ["eventCode", "updatedAt", "toggle"];

    constructor(private store: Store<AppState>) {
        this.settings$ = this.store.select(selectEmailNotificationSettings);
        this.loading$ = this.store.select(selectEmailNotificationSettingsLoading);
        this.error$ = this.store.select(selectEmailNotificationSettingsError);
        this.updatingEventCode$ = this.store.select(
            selectEmailNotificationSettingsUpdatingEventCode,
        );
    }

    ngOnInit(): void {
        this.store.dispatch(EmailNotificationSettingsActions.loadSettings());
    }

    toggle(eventCode: string, isEnabled: boolean): void {
        this.store.dispatch(
            EmailNotificationSettingsActions.updateSetting({
                eventCode,
                isEnabled,
            }),
        );
    }

    getDisplayName(eventCode: string): string {
        if (eventCode === "Undefined") {
            return "Undefined (unparseable)";
        }

        return eventCode
            .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
            .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
            .trim();
    }
}
